export { default } from './Flipper';



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Flipper/index.js
 **/